import React from 'react' 
import { useEffect } from 'react';
import { useLocation, NavLink,Link } from 'react-router-dom'; 
import Highlights from'../Component/Highlights' 
import LazyLoad from 'react-lazyload'
const Header = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);
  return (
        <>
        <div className='top-nav'>
            <div className='sch_dtl'>
                <p><i class="bi bi-person-fill"></i> Affiliation No :  <img src="https://webapi.entab.info/api/image/CCSDH/public/Images/school.png" className='img-fluid' /> Recognition No. : PSR122022138</p>
            </div>
        <Highlights/>
        </div>
        <div className="header padded-sec">
       
        <div className="logo">
            <NavLink to="/">
                <LazyLoad><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/logo.png" alt="Carmel Convent School, dharuhera" className="img-fluid"/></LazyLoad></NavLink>
        </div>
        <div className="header-nav">
    <div className='d-flex'>
        <button><Link to="https://webapi.entab.info/api/image/CCSDH/public/pdf/booklist.pdf" target="_blank"><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/booklist.png" className='img-fluid'></img> Book List </Link></button>
        <button><Link to="/CBSEDisclosure"><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/cbseicon.png" className='img-fluid'></img> Mandatory Disclosure</Link></button>
        <button><img src="https://webapi.entab.info/api/image/CCSDH/public/Images/virtual_tour.png" className='img-fluid'></img> Campus Virtual Tour</button>
    </div>
            <nav className="navbar navbar-expand-lg">
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#main_nav">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="main_nav">
                <ul className="navbar-nav">
                    <li className="nav-item active"> <NavLink  className="dropdown-item" to="/"><i class="bi bi-house-fill"></i></NavLink></li>
                     <li className="nav-item dropdown">
                     
                       <div className="nav-link"  data-bs-toggle="dropdown">  about us </div> 
                            <ul className="dropdown-menu fade-up"> 
                                <li><NavLink  className="dropdown-item" to="/AboutUs">About Us</NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/OurHistory">Our History</NavLink></li>
                                  <li><NavLink  className="dropdown-item" to="/VisionMission">Vision Mission</NavLink></li> 
                                <li><NavLink  className="dropdown-item" to="/ManagingCommittee">Managing Committee</NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/PrincipalMessage">Principal's Message</NavLink></li>
                        </ul>   
                    </li> 
                    <li className="nav-item dropdown">
                      <div className="nav-link" data-bs-toggle="dropdown">academics </div>  
                          <ul className="dropdown-menu fade-up"> 
                          <li><NavLink  className="dropdown-item" to="/FeeStructure">Fee Structure</NavLink></li> 
                          <li><NavLink  className="dropdown-item" to="/SchoolUniform">School Uniform</NavLink></li> 
                          <li><NavLink  className="dropdown-item" to="/Infrastructure">Infrastructure</NavLink></li> 
                          <li><NavLink  className="dropdown-item" to="/RulesRegulations">RulesRegulations</NavLink></li> 
                           <li><NavLink  className="dropdown-item" to="/Club">Club</NavLink></li> 
                        </ul>  
                    </li>
                    <li className="nav-item"><NavLink className="dropdown-item" to="/StaffMembers"> Staff  </NavLink></li> 
                    <li className="nav-item dropdown">
                    <div className="nav-link" data-bs-toggle="dropdown">Admission </div>  
                        <ul className="dropdown-menu fade-up"> 
                        <li><NavLink  className="dropdown-item" to="/AgeCriteria">Age Criteria</NavLink></li> 
                        <li><NavLink  className="dropdown-item" to="/Admission">Document required</NavLink></li> 
                        <li><NavLink  className="dropdown-item" to="/EntranceTest">Entrance test</NavLink></li>  
                      </ul>  
                  </li>

                    <li className="nav-item"><NavLink className="dropdown-item" to="/Events">events</NavLink></li> 
                      
                   
                    
                    <li className="nav-item"><NavLink className="dropdown-item" to="/"> awards & honours</NavLink></li> 
                     
                    <li className="nav-item dropdown"> 
                        <div className="nav-link"  data-bs-toggle="dropdown"> Gallery</div> 
                            <ul className="dropdown-menu fade-up"> 
                                <li><NavLink  className="dropdown-item" to="/Gallery">Gallery</NavLink></li>
                                <li><NavLink  className="dropdown-item" to="/VideoGallery"> Video Gallery</NavLink></li> 
                        </ul>   
                    </li> 
                    <li className="nav-item"><NavLink className="dropdown-item" to="/ContactUs"> Contact us </NavLink></li> 
                </ul>
                </div> 
           </nav>
        </div>
        
    </div>
    </>
  )
}

export default Header
